<script>

import { Overlay } from '../../'

export default {
    name: 'ZScore',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Z-Score - Statistical deviation from mean',
                preset: {
                    name: 'Z-Score $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#9c27b0',
                        bandColor: '#aaa'
                    }
                }
            }
        },
        use_for() { return ['ZScore'] },
        calc() {
            return {
                props: {
                    length: { def: 20, text: 'Length' }
                },
                conf: { renderer: 'Splines' },
                update: `
                    // Simple Z-Score calculation
                    let mean = sma(close, length)[0]
                    
                    // Manual standard deviation calculation
                    let sum_squared_diff = 0
                    for (let i = 0; i < length; i++) {
                        sum_squared_diff += Math.pow(close[i] - mean, 2)
                    }
                    let std = Math.sqrt(sum_squared_diff / length)
                    
                    let zscore = (close[0] - mean) / std
                    return zscore
                `
            }
        }
    }
}
</script>
